export const schools = [
  { id: 33, name: 'Escuela 1' },
  { id: 34, name: 'Escuela 2' }
]

export const categoryMetric = [
  {
    categoryName: 'Pensamiento computacional',
    categoryId: 1,
    percentage: 46
  },
  {
    categoryName: 'Ciudadanía global',
    categoryId: 2,
    percentage: 30
  },
  {
    categoryName: 'Espíritu emprendedor',
    categoryId: 3,
    percentage: 24
  }
]

const skillsValues = {
  logicalThinking: {
    lowAge: [
      { name: 'Flexibilidad', value: 16 },
      { name: 'Resiliencia', value: 12 },
      { name: 'Creatividad', value: 20 },
      { name: 'Trabajo en equipo', value: 30 },
      { name: 'Resolución de problemas', value: 22 }
    ],
    highAge: [
      { name: 'Compromiso y responsabilidad', value: 16 },
      { name: 'Resiliencia', value: 12 },
      { name: 'Análisis', value: 20 },
      { name: 'Iniciativa', value: 30 },
      { name: 'Comunicación', value: 22 }
    ]
  },
  globalCitizenship: {
    lowAge: [
      { name: 'Flexibilidad', value: 16 },
      { name: 'Trabajo en equipo', value: 12 },
      { name: 'Pensamiento crítico', value: 20 },
      { name: 'Liderazgo', value: 30 },
      { name: 'Resolución de problemas', value: 22 }
    ],
    highAge: [
      { name: 'Análisis', value: 16 },
      { name: 'Perseverancia', value: 12 },
      { name: 'Creatividad', value: 20 },
      { name: 'Compromiso y responsabilidad', value: 30 },
      { name: 'Resolución de problemas', value: 22 }
    ]
  },
  entrepreneurship: {
    lowAge: [
      { name: 'Análisis', value: 5 },
      { name: 'Pensamiento crítico', value: 10 },
      { name: 'Perseverancia', value: 12 },
      { name: 'Creatividad', value: 13 },
      { name: 'Liderazgo', value: 30 },
      { name: 'Compromiso y responsabilidad', value: 22 },
      { name: 'Iniciativa', value: 20 }
    ],
    highAge: [
      { name: 'Flexibilidad', value: 16 },
      { name: 'Resiliencia', value: 12 },
      { name: 'Iniciativa', value: 20 },
      { name: 'Comunicación', value: 30 },
      { name: 'Resolución de problemas', value: 22 }
    ]
  }
}

export const getSkillsObject = (category, age) => skillsValues[category][age].map(skill => ({
  skill: {
    name: skill.name
  },
  percentage: skill.value
}))

export const chosenSkills = [
  {
    'category': {
      id: 1,
      name: 'Pensamiento computacional',
      imageURL: 'ilus_pensamiento.svg'
    },
    skillPercentages: [
      {
        ageRangeVO: { 'minAge': 12, 'maxAge': 15 },
        skillPercentageVOs: getSkillsObject('logicalThinking', 'lowAge')
      },
      {
        ageRangeVO: { 'minAge': 16, 'maxAge': 18 },
        skillPercentageVOs: getSkillsObject('logicalThinking', 'highAge')
      }
    ]
  },
  {
    'category': {
      id: 2,
      name: 'Ciudadanía global',
      imageURL: 'ilus_ciudadania.svg'
    },
    skillPercentages: [
      {
        ageRangeVO: { 'minAge': 12, 'maxAge': 15 },
        skillPercentageVOs: getSkillsObject('globalCitizenship', 'lowAge')
      },
      {
        ageRangeVO: { 'minAge': 16, 'maxAge': 18 },
        skillPercentageVOs: getSkillsObject('globalCitizenship', 'highAge')
      }
    ]
  },
  {
    'category': {
      id: 3,
      name: 'Espíritu emprendedor',
      imageURL: 'ilus_emprendimiento.svg'
    },
    skillPercentages: [
      {
        ageRangeVO: { 'minAge': 12, 'maxAge': 15 },
        skillPercentageVOs: getSkillsObject('entrepreneurship', 'lowAge')
      },
      {
        ageRangeVO: { 'minAge': 16, 'maxAge': 18 },
        skillPercentageVOs: getSkillsObject('entrepreneurship', 'highAge')
      }
    ]
  }
]

export const methodologies = [
  { methodology: 'Workshop', percentage: 40 },
  { methodology: 'Project', percentage: 15 },
  { methodology: 'Case', percentage: 15 },
  { methodology: 'DidacticSequence', percentage: 20 },
  { methodology: 'Exercise', percentage: 10 }
]

export const reviewCategory = [
  { reviewCategory: 1, percentage: 10 },
  { reviewCategory: 2, percentage: 20 },
  { reviewCategory: 3, percentage: 40 },
  { reviewCategory: 4, percentage: 20 },
  { reviewCategory: 5, percentage: 10 }
]
